// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1it7t","label":"Section_label__33Lt6","contentWrap":"Section_contentWrap__2MAw2","footer":"Section_footer__ODRMW","footerInner":"Section_footerInner__2R8vP"};